// extracted by mini-css-extract-plugin
export default {"partners-img":"PartnersCard_partners-img__F4Pwr","partners-caption":"PartnersCard_partners-caption__23scJ"};